export default "__VITE_ASSET__D6XV02xy__"